import { FC } from "react";
import { ListItem } from "@mui/material";
import "@/components/navigation/navigationBar.css";
import {
  NavigationItemButton,
  NavigationListItemContent,
  NavigationNavLink,
} from "@/components/navigation/navigationItems";
import Restricted from "@/consumer/restricted";
import { useTranslation } from "react-i18next";
import { documentWorkspacePermission } from "@/helper/documentPermissions";

interface Props {
  drawerOpen: boolean;
  selectedIndex: number;
  handleListItemClick?: any;
}

const GeneralRoutes: FC<Props> = ({
  drawerOpen,
  selectedIndex,
  handleListItemClick,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Restricted permissionRequired="frontend_view_home">
        <ListItem
          disablePadding
          className={drawerOpen ? "navigationItemOpen" : "navigationItem"}
        >
          <NavigationNavLink to={"/"}>
            <NavigationItemButton
              drawerOpen={drawerOpen}
              onClick={(event: any) => handleListItemClick(event, 0)}
              selected={selectedIndex === 0}
            >
              <NavigationListItemContent
                icon="home"
                primaryText={t("home_nav")}
                drawerOpen={drawerOpen}
              />
            </NavigationItemButton>
          </NavigationNavLink>
        </ListItem>
      </Restricted>
      <Restricted permissionRequired="frontend_view_user_todo">
        <ListItem
          disablePadding
          className={drawerOpen ? "navigationItemOpen" : "navigationItem"}
        >
          <NavigationNavLink to="/todo">
            <NavigationItemButton
              drawerOpen={drawerOpen}
              onClick={(event: any) => handleListItemClick(event, 1)}
              selected={selectedIndex === 1}
            >
              <NavigationListItemContent
                icon="todo"
                primaryText={t("todo_single")}
                drawerOpen={drawerOpen}
              />
            </NavigationItemButton>
          </NavigationNavLink>
        </ListItem>
      </Restricted>
      <Restricted
        permissionRequired={documentWorkspacePermission(
          window.location.hostname.split(".")[0]
        )}
      >
        <ListItem
          disablePadding
          className={drawerOpen ? "navigationItemOpen" : "navigationItem"}
        >
          <NavigationNavLink to="/document">
            <NavigationItemButton
              drawerOpen={drawerOpen}
              onClick={(event: any) => handleListItemClick(event, 2)}
              selected={selectedIndex === 2}
            >
              <NavigationListItemContent
                icon="document"
                primaryText={t("documents")}
                drawerOpen={drawerOpen}
              />
            </NavigationItemButton>
          </NavigationNavLink>
        </ListItem>
      </Restricted>
    </>
  );
};

export default GeneralRoutes;
